import React from "react";
import DAAModuleSubtopic from "../DAAModuleSubtopic";

const DAA_NQueen = () => (
  <DAAModuleSubtopic
    title="Backtracking – N-Queens Problem"
    videos={[
      "https://www.youtube.com/embed/xFv_Hl4B83A",
      "https://www.youtube.com/embed/ZulXRl_csPA"
    ]}
    takeaways={[
      { text: "Worst-case time complexity: O(N!), due to branching in each row." },
      { text: "Backtracking is used to prune invalid paths early." },
      { text: "Can generate all valid board configurations, not just one." },
      { text: "Applications: Sudoku, Puzzle solvers, Constraint satisfaction problems." }
    ]}
    questions={[
      {
        text: "Demonstrate N Queen problem for N=5, showing steps with backtracking to generate all solutions where no queens attack each other. Include the algorithm and time complexity analysis."
      },
      {
        text: "Explain the N-Queens algorithm on a 4x4 board using backtracking. Draw the State-space Tree with rows and columns numbered 1 through 4."
      },
      {
        text: "Define 6-Queens problem. Assume column-wise placement and an intermediate state where queens are attacking each other. Show how backtracking corrects it to a valid solution.",
        image: "/Nqueen.png"
      },
      {
        text: "Solve the N-Queens problem (e.g. N = 4, 8) using backtracking and explain it with a valid example."
      }
    ]}
    exampleVideos={[
      "https://www.youtube.com/embed/3GqhzSnt2Gc?list=PL-Y5_GYVx275I87vW3LUzEJ-g7TDgn0Ts",
      "https://www.youtube.com/embed/Cc4mqUNig-c?list=PL-Y5_GYVx275I87vW3LUzEJ-g7TDgn0Ts"
    ]}
  />
);

export default DAA_NQueen ;
